import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalDrawer: {
    defaultMessage: 'Import Inventory from CSV',
    id: 'eUvEme',
    description: 'Inventory Import Modal Title',
  },
  createConfigStep: {
    defaultMessage: 'Upload File',
    id: 'IQ2vdL',
    description: 'Title on the first step of the import process',
  },
  createMappingStep: {
    defaultMessage: 'Match Fields',
    id: 'ZUIKqi',
    description: 'Create mapping step title message',
  },
  importResult: {
    id: 'tVxLuI',
    defaultMessage: 'Import Inventory',
    description: 'Title of import is processing step',
  },
  importResultSuccess: {
    id: '/tLzg7',
    defaultMessage: 'Inventory Successfully Imported',
    description: 'Title of success import',
  },
});

export const fieldsTranslations = defineMessages({
  sku: {
    defaultMessage: 'SKU',
    id: '7L+beZ',
    description: 'SKU inventory import column name',
  },
  name: {
    defaultMessage: 'Product Name',
    id: '1itMI0',
    description: 'Product Name inventory import column name',
  },
  loc_1: {
    defaultMessage: 'Area',
    id: 'iZN02y',
    description: 'Area inventory import column name',
  },
  loc_2: {
    defaultMessage: 'Unit',
    id: 'wmC1uD',
    description: 'Unit inventory import column name',
  },
  loc_3: {
    defaultMessage: 'Shelf',
    id: 'mkgQQg',
    description: 'Shelf inventory import column name',
  },
  loc_4: {
    defaultMessage: 'Bin',
    id: 'TrWzPP',
    description: 'Bin inventory import column name',
  },
  stock: {
    defaultMessage: 'On Hand',
    id: 'dBBMPe',
    description: 'On Hand inventory import column name',
  },
  reorder_threshold: {
    defaultMessage: 'Reorder Threshold',
    id: 'oPBRiZ',
    description: 'Reorder Threshold inventory import column name',
  },
  cost: {
    defaultMessage: 'Cost',
    id: 'uphlfn',
    description: 'Cost inventory import column name',
  },
  lot: {
    defaultMessage: 'Lot ID',
    id: 'qRey7+',
    description: 'Lot ID inventory import column name',
  },
  expiration_date: {
    defaultMessage: 'Expiration Date',
    id: 'MEGcH+',
    description: 'Expiration Date inventory import column name',
  },
  barcode: {
    defaultMessage: 'Barcode',
    id: 'P3v6IH',
    description: 'Barcode inventory import column name',
  },
});
